define('hadoop/pageid-helper',['adlhelpers', 'basil', 'domhelpers', 'edap'], function(ADL, Basil, domHelpers, edap) {
    'use strict';

    function PageIdHelper() {
        var adl = new ADL(),
            storedIdKey = 'parentPageviewId',
            parentPageviewIdObj = {}; // will have two properties, id and sessionid

        /**
        *  Options for configuring Basil
        */
        this.basilOpts = {
            namespace: 'edap',
            storages: ['local', 'cookie']
        };


        /**
        *  Cached Basil instance
        */
        this.basil = new Basil(this.basilOpts);

        /**
        *  Gets the data associated with the key in storage.
        *
        *  @param {String} [key] - The key the data is associated with
        *  @returns {Object} - The data object from LocalStorage associated with the key, or null
        *                      if the key is missing or an error occurs in decoding the data
        */
        this.getDataByKey = function(key) {
            var data = null;

            try {
                data = this.basil.get(key);
            } catch (e) {
                edap.error(e);
                this.basil.remove(key);
            }

            return data;
        };


        /**
        *  Sets a key-value pair in LocalStorage
        *
        *  @param {String} [key] - The key to store the data
        *  @param {Object} [value] - The data that will be stored
        *  @returns {Boolean} - true if the data was set, false if it was not
        */
        this.setData = function(key, value) {
            try {
                return this.basil.set(key, value);
            } catch (e) {
                edap.error(e);
            }

            return false;
        };


        /**
         * Encapsulates logic of fallback for determining session ID
         *
         * @param  {Object} data The ADL Helpers data object to use for this session ID
         * @return {String}      The session ID
         */
        this.getSessionId = function(data) {
            // Fallback order: ADL.sessionid, 'has' cookie, '-1'
            var id;

            if (data.isSet('sessionid')) {
                return data.get('sessionid');
            }

            id = domHelpers.getCookie('has');

            if (data.shouldSet(id)) {
                return id;
            }

            return '-1';
        };


        /**
         * Determines whether we should consider two session IDs to be a match
         *
         * @param  {String} id1 The first session ID to compare
         * @param  {String} id2 The second session ID to compare
         * @return {Boolean}    Whether the IDs were considdered to be a match
         */
        this.sessionIdsMatch = function(id1, id2) {
            return adl.shouldSet(id1) && adl.shouldSet(id2) && id1 === id2;
        };


        /**
        * Stores the current pageview ID
        *
        * @param  {String} pageviewId The current pageview from the ADL
        * @param {Object} [data] - The ADL Helpers data object to use
        */
        this.storeCurrentPageviewId = function(pageviewId, data) {
            var that = this;

            // The currently stored pageview ID is the parent pageview ID. Before overwriting it,
            // we need to grab it for use with any events on this page.
            that.cacheParentPageviewId(data);

            that.setData(storedIdKey, {
                id: pageviewId,
                sessionid: that.getSessionId(data)
            });
        };


        /**
        * Retrieves and caches the parent pageview ID
        *
        * @param {Object} [data] - The ADL Helpers data object to use
        */
        this.cacheParentPageviewId = function(data) {
            var that = this,
                idObj = that.getDataByKey(storedIdKey) || {},
                currentSessionId = that.getSessionId(data);

            if (!that.sessionIdsMatch(idObj.sessionid, currentSessionId)) {
                idObj.id = '-1';
            }

            parentPageviewIdObj = idObj;
        };


        /**
        * Getter for the parent pageview ID
        * Checks that the ID is for the current session
        *
        * @param {Object} [data] - The ADL Helpers data object to use
        * @return {String} The pageview ID of the previous page
        */
        this.getParentPageviewId = function(data) {
            var that = this,
                currentSessionId = that.getSessionId(data);

            if (!that.sessionIdsMatch(parentPageviewIdObj.sessionid, currentSessionId)) {
                parentPageviewIdObj.id = '-1';
            }

            return parentPageviewIdObj.id;
        };
    }

    return new PageIdHelper();
});

